import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import PropTypes from 'prop-types';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import { ModalService } from 'ui-components/services/modal-service';
import { TransparencyModal } from '../../../../../components/modals/transparency-modal';
import { ItemQuantityColumnId } from '../../items-table/columns/item-quantity/item-quantity';
import messages from '../messages';

import style from './style.module.less';

const ItemAttributesKey = 'attributes';
const IsTransparencyEnabled = 'istransparencyenabled';

const Caret = ({ isOpen = false }) => {
  const icon = isOpen ? faCaretDown : faCaretRight;

  return (
    <FlexRow className={style.caret}>
      <FontAwesomeIcon icon={icon} />
    </FlexRow>
  );
};

Caret.propTypes = {
  isOpen: PropTypes.bool,
};

const renderTransparencyButton = (row) => {
  const itemQuantity = row.original[ItemQuantityColumnId] || 1;
  const openTransparencyModal = (quantity) => {
    const { salesOrderItemId, fulfillmentPlanItemId } = row.original || {};

    if (!salesOrderItemId) {
      return;
    }

    ModalService.launchModal({
      component: TransparencyModal,
      props: {
        itemQuantity: quantity,
        salesOrderItemId,
        fulfillmentPlanItemId,
      },
    });
  };

  return (
    <div>
      <Button onClick={() => openTransparencyModal(itemQuantity)} theme='link'>
        Enter Transparency Codes
      </Button>
    </div>
  );
};

const AttributeRow = ({ row }) => {
  const attributes = row.original?.[ItemAttributesKey] || [];

  if (!attributes?.length) {
    return null;
  }

  return (
    <FlexRow className={style['items-table-sub-row']}>
      <FlexColumn>
        <div {...row.getToggleRowExpandedProps()} className={style['attribute-row-toggle']}>
          <Caret isOpen={row.isExpanded} />
          <Text element='span' textType={TextType.Caption} value={messages.attributeRowPrompt} />
        </div>
        {row.isExpanded ? (
          <>
            {/* Render all attributes */}
            {
              attributes
                .map((attribute, index) => {
                  if (attribute.name?.toLowerCase() === IsTransparencyEnabled && attribute.value?.toLowerCase() === 'true') {
                    return renderTransparencyButton(row);
                  }

                  if (attribute.name?.toLowerCase() === IsTransparencyEnabled) {
                    return null;
                  }

                  return (
                    <div key={index}>
                      <Text textType={TextType.Label} value={`${attribute.name}:`} />
                      <Text element='span' textType={TextType.Paragraph} value={` ${attribute.value}`} />
                    </div>
                  );
                })
                .filter(Boolean) // Filter out null elements
            }
          </>
        ) : null}
      </FlexColumn>
    </FlexRow>
  );
};

AttributeRow.propTypes = {
  row: PropTypes.shape({
    getToggleRowExpandedProps: PropTypes.func.isRequired,
    isExpanded: PropTypes.bool,
    original: PropTypes.shape({
      [ItemAttributesKey]: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired,
        }),
      ),
    }).isRequired,
  }).isRequired,
};

export { AttributeRow };
